import React, { useState, useEffect } from 'react';
import { AnswerData } from '../../../types/surveyTypes';
import { MultiSelect } from '@mantine/core';

interface AutocompleteAnswersProps {
  answers: AnswerData[];
  onChange: (id: string) => void;
}

const AutocompleteAnswers: React.FC<AutocompleteAnswersProps> = ({
  answers,
  onChange,
}) => {
  const selectedAnswers = answers.filter(x => x.is_user_answer);
  const options = answers.map((answer) => answer.text);
  const [selectedOptions, setSelectedOptions] = useState(selectedAnswers.map((answer) => answer.text));

  useEffect(() => {
    selectedOptions.forEach((option: string) => {
      const id = answers.find(answer => answer.text === option)?.id;
      if (id && !selectedAnswers.some((answer) => answer.id === id)) {
        onChange(id);
      }
    });

    selectedAnswers.forEach((answer: AnswerData) => {
      if (!selectedOptions.includes(answer.text)) {
        onChange(answer.id);
      }
    });
  }, [selectedOptions, selectedAnswers, answers, onChange]);

  const handleAutocompleteChange = (newSelectedOptions: string[]) => {
    setSelectedOptions(newSelectedOptions);
  };

  return (
    <MultiSelect
      data={options}
      onChange={handleAutocompleteChange}
      value={selectedOptions}
      placeholder="Type to search"
      searchable
      nothingFound="Nothing found"
    />
  );
};

export default AutocompleteAnswers;
